import { DEFAULT_DATE_TIME_FORMAT } from 'constants/common'
import DateTimeFormatTypes from 'store/actionTypes/dateTimeFormat'
import UserTypes from 'store/actionTypes/user'

const initialData = {
  list: [],
  pagination: {},
  filter: DEFAULT_DATE_TIME_FORMAT
}

const dateTimeFormat = (state = initialData, action = {}) => {
  const { payload } = action
  switch (action.type) {
    case UserTypes.LOGOUT_SUCCESS:
      return initialData
    case DateTimeFormatTypes.GET_DATETIME_FORMATS_BY_LANGUAGE_SUCCESS:
      return {
        ...state,
        list: payload?.items
      }
    case DateTimeFormatTypes.UPDATE_FILTER_DATETIME_FORMAT_SUCCESS:
      return { ...state, filter: payload }
    case DateTimeFormatTypes.CLEAR_FILTER_DATETIME_FORMAT_SUCCESS:
      return { ...state, filter: initialData.filter }
    default:
      return state
  }
}

export default dateTimeFormat
